import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/24/outline';
import userStore from '../../store/userStore';

/**
 * Bienvenida del gestor (docs/onboarding-ar-plan.md): una tarjeta, una vez. Su
 * trabajo se aprende usándolo; esto solo le dice dónde está cada cosa.
 * Cerrarla es para siempre en este navegador.
 */
export const welcomeKey = userId => `bienvenida-gestor-${userId}`;

const readSeen = userId => {
  try {
    return localStorage.getItem(welcomeKey(userId)) === '1';
  } catch {
    return false;
  }
};

const GestorWelcome = () => {
  const { user } = userStore();
  const [seen, setSeen] = useState(() => readSeen(user?.id));

  if (user?.role !== 'gestor' || seen) return null;

  const cerrar = () => {
    try {
      localStorage.setItem(welcomeKey(user?.id), '1');
    } catch {
      // Sin almacenamiento, se cierra hasta recargar.
    }
    setSeen(true);
  };

  return (
    <section aria-label='Bienvenida' className='mb-8 rounded-lg border border-blue-200 bg-blue-50 p-5'>
      <div className='flex items-start justify-between gap-4'>
        <h2 className='text-base font-semibold text-slate-800'>Te damos la bienvenida</h2>
        <button
          type='button'
          onClick={cerrar}
          className='rounded-lg p-1 text-slate-500 hover:bg-blue-100 hover:text-slate-700'
          aria-label='Cerrar'
          title='Cerrar'
        >
          <XMarkIcon className='h-5 w-5' />
        </button>
      </div>
      <ul className='mt-3 space-y-1.5 text-sm text-slate-700'>
        <li>
          <Link to='/assignments' className='font-medium text-blue-700 hover:underline'>
            Tareas
          </Link>
          : lo que te toca hoy, con lo más urgente arriba.
        </li>
        <li>
          <Link to='/ar-review' className='font-medium text-blue-700 hover:underline'>
            Revisión IA
          </Link>
          : lo que la IA propone mandar. Apruébalo o hazlo tú; mientras esté pendiente, ese expediente espera.
        </li>
        <li>
          <Link to='/call-session' className='font-medium text-blue-700 hover:underline'>
            Llamadas
          </Link>
          : la cola de deudores a los que llamar, con tu número.
        </li>
      </ul>
    </section>
  );
};

export default GestorWelcome;
